<template>
    <mobile-admin-collapse-tab title="Emprunts" :badge="getBadgeOrNull('emprunts')">
        <p v-if="!emprunts.length">Aucune demande pour l'instant</p>
        <div v-for="(emprunt, index) in emprunts" :key="'emprunt_' + emprunt.id">
            <hr v-if="index"/>
            <p class="text-center">
                <user-name :user="emprunt.utilisateur"/>
            </p>
            <p>
                {{ formatDates(emprunt) }} <br/>
                <span v-if="emprunt.jeux.length">
                    <em>Jeux :</em>  {{ emprunt.jeux.map(({nom}) => nom).join(', ') }} <br/>
                </span>
                <span v-if="emprunt.livres.length">
                    <em>Livres :</em>  {{ emprunt.livres.map(({nom}) => nom).join(', ') }}
                </span>
            </p>
            <p class="text-center">
                <b-button variant="success" pill @click="confirmEmprunt(emprunt, true)">
                    <font-awesome-icon icon="check"/>
                </b-button>
                <b-button variant="danger" pill @click="confirmEmprunt(emprunt, false)">
                    <font-awesome-icon icon="times"/>
                </b-button>
            </p>
        </div>
    </mobile-admin-collapse-tab>
</template>

<script>
    import {mapGetters} from "vuex";

    import {apiPath}            from '@/util/http';
    import alert                from '@/util/alert';
    import demande              from '@/util/demande';
    import {updateBadgesBureau} from '@/util/badge';
    import empruntsMixin        from '@/mixin/empruntsMixin';

    const UserName               = () => import('@/components/UserName');
    const CommentValidationModal = () => import('@/components/modals/CommentValidationModal');
    const MobileAdminCollapseTab = () => import('./MobileAdminCollapseTab');

    export default {
        name: "MobileAdminEmpruntsTab",
        components: {UserName, MobileAdminCollapseTab},
        mixins: [empruntsMixin],
        data: () => ({
            emprunts: []
        }),
        computed: {
            ...mapGetters({getBadgeOrNull: ['badge/getBadgeOrNull']})
        },
        methods: {
            ...demande,
            loadData() {
                alert.loading()
                    .then(() => this.axios.get(apiPath('list_waiting_emprunts_admin')))
                    .then(response => this.emprunts = this.addRowVariant(demande.momentDates(response.data)))
                    .catch(() => this.$toaster.error('Impossible de récupérer la liste des emprunts'))
                    .finally(alert.stopLoading);
            },
            confirmEmprunt(emprunt, valid) {
                this.$store.dispatch('modal/create', {
                    component: CommentValidationModal,
                    props: {
                        title: (valid ? 'Validation' : 'Refus') + " de l'emprunt",
                        commentaireUtilisateur: emprunt.commentaireUtilisateur,
                        callback: (commentaire, notifyDiscord) => this.axios
                            .post(
                                apiPath('confirm_emprunt_admin', {emprunt: emprunt.id}),
                                {valid: valid, commentaire: commentaire, notify_discord: notifyDiscord}
                            )
                            .then(() => {
                                this.$toaster.success('Emprunt ' + (valid ? 'validé' : 'refusé') + ' avec succès');
                                this.loadData();
                                updateBadgesBureau();
                            })
                            .catch(() => this.$toaster.error("Impossible de modifier l'emprunt"))
                    }
                })
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>
    em {
        text-decoration: underline;
    }
</style>